import {
  LinkCategory,
  LinkLabelCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import { ModelConceptHierarchy } from 'src/containers/ProjectDiagram/types/data';
import { getModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { getModelConceptHierarchyLabelKey } from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/createModelConceptHierarchyLabel';
import { RDFS_SUB_CLASS_OF_IRI } from 'src/templates/queries/iris';

export const getModelConceptHierarchyKey = ({
  fromIri,
  value = RDFS_SUB_CLASS_OF_IRI,
  toIri,
}: {
  fromIri: string;
  toIri: string;
  value?: string;
}) => `${LinkCategory.MODEL_CONCEPT_HIERARCHY}-${fromIri}-${value}-${toIri}`;

export const getHierarchyKeyFromLabelKey = (linkKey: string) =>
  linkKey.replace(
    new RegExp(`^${LinkLabelCategory.MODEL_CONCEPT_HIERARCHY_LABEL}`),
    LinkCategory.MODEL_CONCEPT_HIERARCHY
  );

export const createModelConceptHierarchy = ({
  fromIri,
  value = RDFS_SUB_CLASS_OF_IRI,
  toIri,
}: {
  fromIri: string;
  toIri: string;
  value?: string;
}): ModelConceptHierarchy => ({
  key: getModelConceptHierarchyKey({ fromIri, value, toIri }),
  from: getModelConceptClassKey(fromIri),
  value,
  to: getModelConceptClassKey(toIri),
  labelKeys: [getModelConceptHierarchyLabelKey({ fromIri, value, toIri })],
  category: LinkCategory.MODEL_CONCEPT_HIERARCHY,
});
